/* Shield visibility is derived from cart HTML. No cart polling or global network hooks. */
(() => {
  function init() {
    const drawer = document.querySelector('cart-drawer');
    const configNode = document.getElementById('prink-shield-config');
    const template = document.getElementById('prink-shield-template');
    if (!drawer || !configNode || !template || drawer.dataset.prinkShieldBound) return;
    let config;
    try { config = JSON.parse(configNode.textContent); } catch (error) { console.error(error); return; }
    if (!config.variants?.some((variant) => variant.available)) return;
    drawer.dataset.prinkShieldBound = 'true';
    const root = window.Shopify?.routes?.root || '/';
    let scheduled = false;
    let pending = false;
    function hasProduct(path) {
      return Array.from(drawer.querySelectorAll('.cart-item__name[href]')).some((link) => {
        const pathname = new URL(link.href, window.location.origin).pathname.replace(/\/$/, '');
        return pathname.endsWith(path);
      });
    }
    function sync() {
      scheduled = false;
      const current = drawer.querySelector('#cu-upsell');
      const shouldShow = hasProduct(config.mainPath) && !hasProduct(config.shieldPath);
      if (!shouldShow) { current?.remove(); return; }
      if (current) return;
      const footer = drawer.querySelector('.drawer__footer');
      if (!footer) return;
      const card = template.content.firstElementChild.cloneNode(true);
      const select = card.querySelector('.cu-upsell__select');
      const button = card.querySelector('.cu-upsell__btn');
      const errorNode = card.querySelector('.cu-upsell__error');
      const oldPrice = card.querySelector('.cu-upsell__old');
      const price = card.querySelector('.cu-upsell__now');
      const badge = card.querySelector('.cu-upsell__badge');
      const first = config.variants.find((variant) => variant.available);
      function selected() {
        return config.variants.find((variant) => String(variant.id) === select?.value) || first;
      }
      function priceChanged() {
        const variant = selected();
        price.textContent = variant.price;
        const percentage = variant.compareCents > variant.priceCents
          ? Math.round((1 - variant.priceCents / variant.compareCents) * 100) : 0;
        oldPrice.hidden = badge.hidden = percentage < 1;
        oldPrice.textContent = percentage > 0 ? variant.compareAt : '';
        badge.textContent = percentage > 0 ? percentage + '% OFF' : '';
        button.disabled = pending || !variant.available;
      }
      if (select) {
        for (const variant of config.variants) {
          const option = document.createElement('option');
          option.value = String(variant.id);
          option.textContent = variant.title + (variant.available ? '' : ' (Sold out)');
          option.disabled = !variant.available;
          option.selected = variant.id === first.id;
          select.appendChild(option);
        }
        select.addEventListener('change', priceChanged);
      }
      priceChanged();
      button.addEventListener('click', async () => {
        const variant = selected();
        if (pending || !variant.available) return;
        pending = true;
        button.disabled = true;
        if (select) select.disabled = true;
        errorNode.hidden = true;
        button.textContent = 'Adding...';
        let added = false;
        try {
          const response = await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{ id: variant.id, quantity: 1 }],
              sections: ['cart-drawer', 'cart-icon-bubble'],
              sections_url: window.location.pathname,
            }),
          });
          const data = await response.json();
          if (!response.ok || data.status) throw new Error(data.description || 'This item could not be added. Please try again.');
          added = true;
          drawer.setActiveElement(document.getElementById('cart-icon-bubble'));
          drawer.renderContents(data);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'prink-shield', productVariantId: String(variant.id), cartData: data });
          }
        } catch (error) {
          errorNode.hidden = false;
          errorNode.textContent = added
            ? 'Added to your cart. Open the cart page to review your items.'
            : error.message || 'Could not add this item. Please try again.';
          if (added) {
            const link = document.createElement('a');
            link.href = root + 'cart';
            link.textContent = ' Open cart';
            errorNode.appendChild(link);
          }
          button.textContent = added ? 'Added' : '+ Add';
        } finally {
          pending = false;
          button.disabled = added;
          if (select) select.disabled = added;
        }
      });
      footer.before(card);
    }
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      queueMicrotask(sync);
    }
    const observer = new MutationObserver((mutations) => {
      if (mutations.some((mutation) => !mutation.target.closest?.('#cu-upsell'))) schedule();
    });
    observer.observe(drawer, { childList: true, subtree: true });
    drawer.addEventListener('prink:cart-rendered', schedule);
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
